import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SettingsView from '@/views/SettingsView.vue'
import ChamadosView from '@/views/ChamadosView.vue'
import AgendamentosView from '@/views/AgendamentosView.vue'
import TecnicosView from '@/views/TecnicosView.vue'
import AssociacoesView from '@/views/AssociacaoView.vue'

const routes = [
  {  path: '/',  name: 'home',  component: HomeView},
  { path: '/settings', name: 'settings', component: SettingsView },
  { path: '/chamados', name: 'chamados', component: ChamadosView },
  { path: '/agendamentos', name: 'agendamentos', component: AgendamentosView },
  { path: '/tecnicos', name: 'tecnicos', component: TecnicosView },
  { path: '/associacoes', name: 'associacoes', component: AssociacoesView },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router